import React from "react";
import icon from "../../assets/amount.png";

export default function AmountIcon({ size }) {
  return <img src={icon} width={size} />;
}
